import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema, presetSchema } from './schemas';

export const trackerSearchParams = new SearchParams(screenSchema).encoder(
  (schema, params) => {
    return schema.stripDefaults().encode(params, { applyConst: false });
  }
);

export const trackerLink = new Link('tracker', trackerSearchParams);

export const trackerPresetSearchParams = new SearchParams(presetSchema).encoder(
  (schema, params) => {
    return schema.stripDefaults().encode(params, {
      applyConst: false,
      context: {
        stripPayTo: true,
        stripChartLazy: true,
      },
    });
  }
);
export const trackerPresetLink = new Link('tracker', trackerPresetSearchParams);
